// import * as React from 'react'
// import './PromoCodeField.css'
// import '../Components/ContactForm.css';
// import { ContactinformationForm } from '../Types/PaymentFormTypes';
// import FadeIn from '../Animations/FadeIn';
// import Loader from './Loader';
// import { DataService } from '../DataService/DataService';
// import { PromoCodeVerification } from '../Types/PromoCodeTypes';
// import { Icon } from '../Icons/Icon';
// import { stepColors } from '../Pages/PaymentForm';
// interface IPromoCodeField{
//     paymentForm:ContactinformationForm
//     onPromoCodeValidationCallback:()=>void;
//     handleChange:(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
// }
// export const PromoCodeField = ({paymentForm,onPromoCodeValidationCallback,handleChange}:IPromoCodeField) => {
//         //internal loader
//         const [isLoading,setIsLoading] = React.useState<boolean>(false);
//         const promoCodeInternalRef = React.useRef<{message:string,promoCode?:PromoCodeVerification | undefined} | undefined>(undefined);
//         const verifyPromotionCode = async ():Promise<void> => {
//             //gör din fetch
//             if(promoCodeInternalRef.current?.promoCode?.code !== paymentForm.form.promoCode?.value){
//                  setIsLoading(true);
//                  const res = await DataService.PaymentService.SendPromoCodeVerification(paymentForm.form.promoCode?.value as string);
//                  console.log(res)
//                 promoCodeInternalRef.current = res ?? undefined;
//             //kör callback
//             onPromoCodeValidationCallback();
//             setIsLoading(false);
//             }else if(promoCodeInternalRef.current?.promoCode?.code == paymentForm.form.promoCode?.value){
//                 console.log('ref samma gör inget')
//             }
          
//         }
//         const currentCode = paymentForm.form.promoCode?.value;
//         const lastValidated = promoCodeInternalRef.current?.promoCode?.code;
//         const isValidated = lastValidated === currentCode;
       
//        console.log(isValidated)
//         return(
//              <div>
//                 <label htmlFor="city">Kampanjkod</label>
               
//                     <>
//                     <div style={{display:'flex',alignItems:'baseline',gap:5}}>
//                     <input
//                     disabled={isLoading}
//                   type="text"
//                   id="promoCode"
//                   name="promoCode"
//                   minLength={2}
//                   value={paymentForm.form.promoCode?.value ?? ''}
//                   onChange={handleChange}
//                 //   onBlur={verifyPromotionCode}
//                   placeholder="Fyll i kampanjkod om du har någon"
//                   />
//                   {isLoading && (
//                         <FadeIn>
//                         <Loader loaderSize='SMALL' bgColor={'#F39E60'}/>
//                     </FadeIn>
//                   )}
                  
//                     </div>
//                   {paymentForm.form.promoCode?.value &&
//                    (
//                     <div style={{display:'flex',justifyContent:'space-between',alignItems:'baseline',color:stepColors.success}}>

//                         {isValidated ? <div>{promoCodeInternalRef.current?.message}</div> :<div>{promoCodeInternalRef.current?.message} <div onClick={verifyPromotionCode} style={{marginTop:8,gap:5,fontSize:12,padding:0,border:'none',background:'none',display:'flex',flexDirection:'row',alignItems:'center',color:'#4b5563',cursor:'pointer'}} >
//                             Validera kod<Icon.QuestionButton width={20} height={20} fill={'#F39E60'}/>
//                         </div></div>}
//                         {/* {promoCodeInternalRef.current && (promoCodeInternalRef.current.code == paymentForm.form.promoCode?.value) &&<div>{promoCodeInternalRef.current?.description}</div>} 
//                         {promoCodeInternalRef.current?.code !== paymentForm.form.promoCode?.value && (
//                             <div onClick={verifyPromotionCode} style={{marginTop:8,gap:5,fontSize:12,padding:0,border:'none',background:'none',display:'flex',flexDirection:'row',alignItems:'center',color:'#4b5563',cursor:'pointer'}} >
//                             Validera kod<Icon.QuestionButton width={20} height={20} fill={'#F39E60'}/>
//                         </div>
//                         )} */}
                        
//                         </div>
//                    )
//                   }
                  
                  
//                   </>
                
                
//               </div>
//         )

// }
import * as React from 'react'
import './PromoCodeField.css'
import '../Components/ContactForm.css'
import { ContactinformationForm } from '../Types/PaymentFormTypes'
import FadeIn from '../Animations/FadeIn'
import Loader from './Loader'
import { DataService } from '../DataService/DataService'
import { PromoCodeVerification } from '../Types/PromoCodeTypes'
import { Icon } from '../Icons/Icon'

interface IPromoCodeField {
  paymentForm: ContactinformationForm
  onPromoCodeValidationCallback: () => void
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
}

export const PromoCodeField = ({
  paymentForm,
  onPromoCodeValidationCallback,
  handleChange,
}: IPromoCodeField) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
    const [isDirty, setIsDirty] = React.useState(false)
    const [hasValidated, setHasValidated] = React.useState(false);
const handleChangeInternal = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  setIsDirty(true);
  handleChange(e);

  if (!e.target.value) {
    promoCodeInternalRef.current = undefined;
  }
};
  // Cacha senaste validerade svar
  const promoCodeInternalRef = React.useRef<{
    message: string
    promoCode?: PromoCodeVerification | undefined
  }>(undefined);

  const currentCode = paymentForm.form.promoCode?.value ?? ''
  const lastValidatedCode = promoCodeInternalRef.current?.promoCode?.code
  const isValidated = !isDirty && lastValidatedCode === currentCode
  const hasError =
   hasValidated && promoCodeInternalRef.current && !promoCodeInternalRef.current.promoCode;


 const verifyPromotionCode = async (): Promise<void> => {
  if (!currentCode) return;
  if (lastValidatedCode === currentCode) return;

  setIsLoading(true);
  try {
    const res =
      (await DataService.PaymentService.SendPromoCodeVerification(currentCode)) ??
      { message: 'Ett okänt fel uppstod', promoCode: undefined };

    promoCodeInternalRef.current = res;
    setIsDirty(false);
    setHasValidated(true);
    onPromoCodeValidationCallback();
  } catch (err) {
    promoCodeInternalRef.current = {
      message: 'Ett tekniskt fel uppstod vid validering',
      promoCode: undefined,
    };
    setHasValidated(true);
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div className="promo-code-field">
      <label htmlFor="promoCode" className="promo-code-label">Kampanjkod</label>

      <div className="promo-code-input-row">
        <input
          disabled={isLoading}
          type="text"
          id="promoCode"
          name="promoCode"
          minLength={2}
          value={currentCode}
          onChange={handleChangeInternal}
          placeholder="Fyll i kampanjkod om du har någon"
          className={`promo-code-input ${hasError ? 'promo-code-input--error' : ''}`}
        />
        {isLoading && (
          <FadeIn>
            <Loader loaderSize="SMALL" bgColor={'#F39E60'} />
          </FadeIn>
        )}
      </div>

      {/* Meddelande / valideringsstatus */}
{currentCode && (
  <div className={`promo-code-message ${hasError ? 'promo-code-message--error' : 'promo-code-message--success'}`}>
    <div className="promo-code-message-text">{promoCodeInternalRef.current?.message}</div>

    {!isValidated && (
      <button
        type="button"
        onClick={verifyPromotionCode}
        className="promo-code-validate-btn"
      >
        Validera kod <Icon.QuestionButton width={20} height={20} fill={'#F39E60'} />
      </button>
    )}
  </div>
)}
    </div>
  )
}
